import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import { MenuItem, Typography } from '@material-ui/core'
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck'

import { SUBMIT } from 'app/constants/button'

import SubmitDialog from 'app/componentV4/Dialog/SubmitDialog'

const MarkCorrect = (props) => {
  const { closeMenu = () => {}, onAction } = props

  const { formatMessage } = useIntl()

  const [isOpen, setIsOpen] = useState(false)
  const [isDisable, setIsDisable] = useState(false)

  const handleOpen = () => {
    setIsOpen(true)
  }

  const handleClose = () => {
    setIsOpen(false)
    closeMenu()
  }

  return (
    <div>
      <MenuItem onClick={() => handleOpen()} className="space-x-5">
        <PlaylistAddCheckIcon fontSize="small" className="text-blue-950" />
        <Typography className="text-14 font-400 text-blue-950">
          {formatMessage({
            id: 'subscriber.dialog.markAsCorrect.items.title',
          })}
        </Typography>
      </MenuItem>

      <SubmitDialog
        id="dialog-mark-correct-contact"
        open={isOpen}
        type={SUBMIT}
        disabledSubmit={isDisable}
        title={`${formatMessage({
          id: 'subscriber.dialog.markAsCorrect.items.title',
        })}?`}
        description={formatMessage(
          {
            id: 'subscriber.dialog.markAsCorrect.description',
          },
          {
            count: 1,
          },
        )}
        submitText={formatMessage({
          id: 'action.confirm',
        })}
        onSubmit={() => {
          onAction()
          handleClose()
        }}
        closeText={formatMessage({
          id: 'text.close',
        })}
        onClose={() => handleClose()}
      />
    </div>
  )
}

MarkCorrect.propTypes = {
  onAction: PropTypes.func,
  closeMenu: PropTypes.func,
}

export default MarkCorrect
